import { useGameContext } from "../context/GameContext";
import "./Menu.css";

const mainClass = "Menu";

const Menu = ({ resetGameStats, resetBoard }: any) => {
  const { setGameOver, setIsGameLobby } = useGameContext();

  const handleClickPlay = () => {
    setGameOver(false);
    setIsGameLobby(false);
    resetGameStats();
    resetBoard();
  };

  return (
    <div className={mainClass}>
      <button
        onClick={handleClickPlay}
        className={`${mainClass}--play-button`}
        type="submit"
      >
        Play
      </button>
    </div>
  );
};

export default Menu;
